import React from 'react'
import { font } from './constants'
import fieldStyles from './FormField.module.css'

function FormTextArea({ label, placeholder, helpText, required, value, onChange, variant = 'light' }) {
  const isLight = variant === 'light'
  const labelColor = isLight ? '#6b6b6b' : '#b0b8c8'
  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ display: 'block', fontSize: isLight ? 13 : 14, color: labelColor, marginBottom: isLight ? 5 : 6, fontFamily: font }}>
        {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
      </label>
      <textarea
        className={isLight ? fieldStyles.textareaLight : undefined}
        placeholder={placeholder}
        value={value || ''}
        onChange={e => onChange?.(e.target.value)}
        rows={3}
        style={{
          background: isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.04)',
          border: isLight ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.08)',
          borderRadius: 8,
          padding: '10px 14px',
          color: isLight ? '#363636' : '#e2e8f0',
          fontSize: 14,
          width: '100%',
          fontFamily: font,
          outline: 'none',
          resize: 'vertical',
          boxSizing: 'border-box',
        }}
      />
      {helpText && (
        <p style={{ fontSize: 12, color: isLight ? '#999999' : '#6b7a90', marginTop: 4, fontFamily: font, lineHeight: 1.4 }}>{helpText}</p>
      )}
    </div>
  )
}

export default FormTextArea
